import { FC, useState } from 'react';
import styled from 'styled-components';

import FiltersDropdown from '@/components/FilterDropdown';
import FilterButton from '@/components/FilterDropdown/FilterButton';
import FilterRadioButton from '@/components/FilterDropdown/FilterRadioButton';
import {
  FilterGroupBody,
  FilterGroupHeader,
  FilterGroupTitle,
  FilterWrap,
} from '@/components/FilterDropdown/Parts';
import Tooltiped from '@/components/Tooltiped';

const StyledFilterButton = styled(FilterButton)`
  margin: 0 !important;
  border-color: ${({ theme }) => theme.colors.grayscale};

  &:hover {
    border-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

interface Props {
  setValue: React.Dispatch<React.SetStateAction<string>>;
  value: string;
}

const CommentRepliedFilter: FC<Props> = ({ value, setValue }) => {
  const [show, setShow] = useState(false);

  return (
    <FilterWrap>
      <Tooltiped title="Comment  Replies">
        <StyledFilterButton
          text=""
          isActive={show}
          icon={
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.4401 8.46847L0.942383 10.4774V2.44169C0.942383 2.30849 0.995568 2.18074 1.09024 2.08655C1.18491 1.99237 1.31331 1.93945 1.44719 1.93945H9.52411C9.658 1.93945 9.7864 1.99237 9.88107 2.08655C9.97574 2.18074 10.0289 2.30849 10.0289 2.44169V7.96624C10.0289 8.09944 9.97574 8.22718 9.88107 8.32137C9.7864 8.41556 9.658 8.46847 9.52411 8.46847H3.4401Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.9707 8.46875V10.9799C3.9707 11.1131 4.02389 11.2409 4.11856 11.335C4.21323 11.4292 4.34163 11.4821 4.47551 11.4821H10.5595L13.0572 13.4911V5.45536C13.0572 5.32216 13.0041 5.19441 12.9094 5.10023C12.8147 5.00604 12.6863 4.95312 12.5524 4.95312H10.0284"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          onClick={(e) => {
            e?.stopPropagation();
            setShow((prev) => !prev);
          }}
          filterApplied={!!value}
        />
      </Tooltiped>
      {show && (
        <FiltersDropdown onClose={() => setShow(false)}>
          <FilterGroupHeader>
            <FilterGroupTitle>Comment Replies</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            <FilterRadioButton
              id={`comments-1`}
              value={''}
              checked={value === ''}
              setValue={setValue}
            >
              All
            </FilterRadioButton>
            <FilterRadioButton
              id={`comments-2`}
              value={'1'}
              checked={value === '1'}
              setValue={setValue}
            >
              Replied
            </FilterRadioButton>
            <FilterRadioButton
              id={`comments-3`}
              value={'0'}
              checked={value === '0'}
              setValue={setValue}
            >
              Unreplied
            </FilterRadioButton>
          </FilterGroupBody>
        </FiltersDropdown>
      )}
    </FilterWrap>
  );
};

export default CommentRepliedFilter;
